/**
 * Simplified version of `generatePath` for `$param`/`:param` route templates.
 *
 * Ported from legacy contract utilities.
 */ export function simplePath(path, _params) {
    if (!_params) {
        return path;
    }
    const params = _params;
    // Ensure `/` is preserved for absolute paths.
    const prefix = path.startsWith('/') ? '/' : '';
    const segments = path.split(/\/+/).map((segment)=>{
        var _exec;
        const { 1: key } = (_exec = /^[:$](\w+)(\??)$/.exec(segment)) !== null && _exec !== void 0 ? _exec : [];
        if (key) {
            var _params_key;
            return encodeURIComponent((_params_key = params[key]) !== null && _params_key !== void 0 ? _params_key : '');
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, '');
    }).filter((segment)=>Boolean(segment));
    return prefix + segments.join('/');
}
